/**
 * UI Module
 *
 * Handles DOM manipulation and user interface updates.
 */

/**
 * Toggles the disabled state of keyword input fields.
 *
 * @param kwInput - The KW number input element.
 * @param kwPasswordInput - The KW password input element.
 * @param userNameInput - The username input element.
 * @param enabled - If true, enables the input fields; if false, disables them.
 * @returns void
 */
export function toggleKwInputs(
  kwInput: HTMLInputElement,
  kwPasswordInput: HTMLInputElement,
  userNameInput: HTMLInputElement,
  enabled: boolean
): void {
  kwInput.disabled = !enabled;
  kwPasswordInput.disabled = !enabled;
  userNameInput.disabled = !enabled;
}

/**
 * Toggles the disabled state of the start button.
 *
 * Sets BOTH the HTML `disabled` attribute AND the `.disabled` CSS class.
 * Setting only one breaks the UX (per AGENTS.md).
 *
 * @param startButton - The start button element.
 * @param enabled - If true, enables the button; if false, disables it.
 * @param buttonText - The text to display on the button.
 * @returns void
 */
export function toggleStartButton(
  startButton: HTMLButtonElement,
  enabled: boolean,
  buttonText: string
): void {
  startButton.disabled = !enabled;
  startButton.innerText = buttonText;
  startButton.classList.toggle("disabled", !enabled);
}

/**
 * Updates the current year in the footer.
 *
 * @param copyrightYearElement - The element to update with the current year.
 * @returns void
 */
export function updateYear(copyrightYearElement: HTMLElement): void {
  const year = new Date().getFullYear();
  if (year) {
    copyrightYearElement.textContent = year.toString();
  }
}
